export default "__VITE_ASSET__TD6sq6f1__"